import React from 'react';
import { Button, Form, Switch, Tooltip } from 'antd';
import { FormItemWrap, configManager } from 'react-structure-admin';
import { useDispatch } from 'react-redux';
import {
  cancelMyPreferences,
  updateMyPreferences
} from 'stores/users/userActions';
import { Drawer } from 'components';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const CurrentUserMyPreferences = ({ data, saving }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      dispatch(updateMyPreferences({ ...data, ...values }));
    });
  };

  const handleCancel = () => {
    dispatch(cancelMyPreferences());
  };

  return (
    <Drawer
      visible
      size="sm"
      title="Minhas preferências"
      onClose={handleCancel}
      footer={
        <>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Voltar
          </Button>
          <Button onClick={handleSubmit} type="primary" loading={saving}>
            Salvar
          </Button>
        </>
      }
    >
      <Form
        {...configManager.getConfig().layout.form}
        form={form}
        initialValues={data}
      >
        <FormItemWrap
          name={['settings', 'schedulingAppEnabled']}
          label="Habilitar agendamento via aplicativo"
          valuePropName="checked"
        >
          <Switch />
        </FormItemWrap>
        <FormItemWrap
          name={['settings', 'hideProfileInApp']}
          label="Ocultar perfil no aplicativo"
          valuePropName="checked"
        >
          <Switch />
        </FormItemWrap>
        <Form.Item
          name={['settings', 'restrictedAccessMedicalRecords']}
          label="Acesso restrito ao prontuário"
          valuePropName="checked"
          tooltip={{
            title:
              'Não permitir que outros profissionais da saúde, ainda que façam parte da equipe multidisciplinar da clínica/consultório, tenham acesso às minhas anotações registradas no prontuários de pacientes.'
          }}
        >
          <Switch />
        </Form.Item>

        <FormItemWrap
          name={['settings', 'allowReceptionStartAndStopService']}
          label="Permitir que a recepcionista finalize os atendimentos agendados?"
          valuePropName="checked"
        >
          <Switch />
        </FormItemWrap>
      </Form>
    </Drawer>
  );
};

export default CurrentUserMyPreferences;
